import {
  SingleStatusChip,
  Tooltip,
} from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";

/**
 * Status chip flagging an org the current account is a direct member of.
 * Leaving an ancestor org does not revoke this direct access.
 */
export const DirectMemberChip = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "organizations.actions.direct_member",
  });
  return (
    <Tooltip testId="direct-member-chip-tooltip" title={t("tooltip")}>
      <SingleStatusChip testId="direct-member-chip" label={t("label")} />
    </Tooltip>
  );
};
